module.exports = __webpack_public_path__ + "static/media/whichThinnerTableBelow.fe907174.mp3";